import { useEffect, useRef, useState } from 'react';

export function JeffAvatar({ reaction = 'idle' }: { reaction?: 'idle' | 'rsvp' | 'yes' | 'no' }) {
  const ref = useRef<HTMLDivElement>(null);
  const [tilt, setTilt] = useState({ x: 0, y: 0 });
  useEffect(() => {
    if (matchMedia('(pointer: coarse)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const move = (event: PointerEvent) => {
      const rect = ref.current?.getBoundingClientRect();
      if (!rect) return;
      setTilt({ x: Math.max(-4, Math.min(4, (event.clientX - rect.left - rect.width / 2) / 65)), y: Math.max(-2.5, Math.min(2.5, (event.clientY - rect.top - rect.height / 2) / 90)) });
    };
    window.addEventListener('pointermove', move, { passive: true });
    return () => window.removeEventListener('pointermove', move);
  }, []);
  return (
    <div ref={ref} className={`jeff-avatar reaction-${reaction}`} style={{ '--head-tilt': `${tilt.x}deg`, '--head-y': `${tilt.y}px` } as React.CSSProperties} aria-label="Vintage Florida birthday badge">
      <span className="badge-socket" aria-hidden="true" />
      <img className="badge-base" src="/assets/og-fl-man-base.webp" alt="Vintage Florida birthday badge with an orange and a gator" />
      <span className="head-rig" aria-hidden="true">
        <img className="badge-head" src="/assets/og-fl-man-head.webp" alt="" />
        <span className="smoke smoke-one" /><span className="smoke smoke-two" /><span className="smoke smoke-three" />
      </span>
    </div>
  );
}
